/* global module, require */
const THREE = require('three'),
	asBuffer = require('../asBuffer'),
	unit = require('../unit');

const a = unit.mm(7.5);

/* unused params
wire = unit.mm(4),
	pin = unit.mm(5),
	g = 'm6', // todo
	b = unit.mm(12),
	l1 = unit.mm(166),
	l2 = unit.mm(122),
	l3 = unit.mm(25);
*/

const rh = THREE.Math.degToRad(90);

/* unknown measurements */

const ol = unit.mm(10),
	th = unit.mm(10),
	x = unit.mm(20),
	y = unit.mm(40),
	z = unit.mm(15);

const points = [
	new THREE.Vector2(a / 2, 0),
	new THREE.Vector2(th / 2, x),
	new THREE.Vector2(th / 2, x + y),
	new THREE.Vector2(a / 2, x + y + z),
];
const geo = new THREE.LatheGeometry(points).rotateX(rh).translate(0, 0, ol);

module.exports = asBuffer(geo);
